/* global lozad imagesLoaded*/ // tUrl等のグローバル変数を宣言する

import './_smoothScroll.js' // スムーズスクロール
// import Swiper from 'swiper' // Swiper
// import PerfectScrollbar from 'perfect-scrollbar' // 独自スクロールバー
// position:styckyのポリフィル
// Stickyfill.add(document.querySelectorAll('.sticky'))

jQuery(function($) {
  let accBtn = 'sp-menu' // このIDを基準としたアコーディオン
  $('#' + accBtn + '-open,#' + accBtn + '-close').on('click', function() {
    $('#' + accBtn + ',#' + accBtn + '-open,#' + accBtn + '-close').toggleClass(
      'active'
    )
    $('body').toggleClass('lock')
  })

  function trunk8() {
    $('.js-t8,.bread').trunk8({
      // 指定要素に行数制限をかける
      lines: 2,
      fill: '...'
    })
    $('.js-t8.line1').trunk8({
      // 指定要素に行数制限をかける
      lines: 1,
      fill: '...'
    })
    $('.js-t8.line3').trunk8({
      // 指定要素に行数制限をかける
      lines: 3,
      fill: '...'
    })
  }
  trunk8()
  $(window).on('load resize ', function() {
    trunk8()
  })

  lozad('.lozad,.chain', {
    rootMargin: '5%',
    loaded: function(el) {
      el.classList.add('active') // 画面に交差した要素をactive
    }
  }).observe()

  $('.js-slick').slick({
    // スライダー
    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
    accessibility: false,
    // 自動再生。trueで自動再生される。
    autoplay: true,
    // 自動再生で切り替えをする時間
    autoplaySpeed: 6000,
    // 自動再生や左右の矢印でスライドするスピード
    speed: 600,
    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
    pauseOnHover: false,
    // 自動再生時にドットにマウスオンで一時停止するかどうか
    pauseOnDotsHover: true,
    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
    cssEase: 'ease',
    // 画像下のドット（ページ送り）を表示
    dots: true,
    // ドットのclass名をつける
    dotsClass: 'js-slick-dot',
    // ドラッグができるかどうか
    draggable: true,
    // 切り替え時のフェードイン設定。trueでon
    fade: true,
    // 左右の次へ、前へボタンを表示するかどうか
    arrows: false,
    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
    infinite: true,
    // 最初のスライダーの位置
    initialSlide: 0,
    // 画像の遅延表示。‘ondemand’or'progressive'
    lazyLoad: 'ondemand',
    // スライドのエリアに画像がいくつ表示されるかを指定
    slidesToShow: 1,
    // 一度にスライドする数
    slidesToScroll: 1,
    // タッチスワイプに対応するかどうか
    swipe: true,
    // 縦方向へのスライド
    vertical: false
    // 表示中の画像を中央へ
    // centerMode: true,
    // 中央のpadding
    // centerPadding: '160px'
  })

  $('#load').each(function() {
    // 画像数を取得
    var imgNum = imagesLoaded('#load-content').images.length
    // 読み込んだ画像の数を格納
    var loadedImg = 0
    // 現在のプログレス値を格納
    var progressNowPosition = 0
    // 1秒間に100回、progressMonitor()を実行する
    var Timer = setInterval(progressMonitor, 1000 / 100)
    // 画像を読み込んだらloadedImgを加算する
    imagesLoaded('#load-content').on('progress', function() {
      loadedImg++
    })
    // 画像の読み込み状況をチェックし、更新する関数
    function progressMonitor() {
      // 読み込んだ画像のパーセンテージ
      var progressPosition = (loadedImg / imgNum) * 100
      // プログレス値を現在値と目標値からイージングする
      progressNowPosition += (progressPosition - progressNowPosition) * 0.1
      $('#bar').css('right', 100 - progressNowPosition + '%')
      // 読み込みが完了した場合の処理
      if (progressNowPosition >= 100) {
        clearInterval(Timer)
        $('#load').fadeOut()
      }
      // イージング計算を完了させる
      if (progressNowPosition > 99.9) {
        progressNowPosition = 100
      }
    }
  })
})
